import StaticSingleton from "../Shared/StaticSingleton";
import { IsProduction } from "./Environment/Environment";

class URLs extends StaticSingleton<URLs> {
    readonly mediaServer: string = process.env.MEDIA_SERVER_URL!;
}

export default new URLs();
